export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fcc8701e45a0df0ec393f4bbb9afa4ef81e65bf68&name=fetchTypeahead!'